import { render, staticRenderFns } from "./deliverySet.vue?vue&type=template&id=13f279fc"
import script from "./deliverySet.vue?vue&type=script&lang=js"
export * from "./deliverySet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f279fc')) {
      api.createRecord('13f279fc', component.options)
    } else {
      api.reload('13f279fc', component.options)
    }
    module.hot.accept("./deliverySet.vue?vue&type=template&id=13f279fc", function () {
      api.rerender('13f279fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/deliverySet.vue"
export default component.exports